export const addQueryParams = (query: string) => {
  if (history.pushState) {
    const baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    const newUrl = `${baseUrl}?${query}`;
    history.pushState(null, '', newUrl);
  } else {
    console.error('History API не поддерживается');
  }
};
